import type { User } from 'better-auth/client'
import { action, listen, type ActionOpt } from './helper'

export default class IframeAPI {
  static $ = Symbol('IframeAPI')

  isReady: boolean = false
  user: User | undefined
  private iframe: HTMLIFrameElement|undefined
  private executor: Promise<User|undefined>|undefined

  constructor(readonly baseURL: string) { }

  async init() {
    if (this.isReady) {
      return this.user
    }

    return this.executor ??= this.load()
  }

  private async load() {
    const iframe = document.createElement('iframe')
    iframe.src = new URL('/iframe-api/', this.baseURL).toString()
    iframe.style.display = 'none'

    window.document.body.appendChild(iframe)

    await new Promise<void>(ok => iframe.addEventListener('load', () => ok()))

    const data = await listen<User|undefined>('init')

    this.iframe = iframe
    this.isReady = true

    return this.user = data
  }

  async destroy() {
    if (this.iframe) {
      this.iframe.remove()
      this.iframe = undefined
    }

    this.isReady = false
    this.user = undefined
    this.executor = undefined
  }

  get action() {
    if (!this.isReady) {
      throw new Error('Not ready')
    }

    const source = this.iframe!.contentWindow!

    const caller = <T>(opt: ActionOpt) => action<T>(source, opt)
    caller.silent = (opt: ActionOpt) => action.silent(source, opt)

    return caller
  }
}
